<div class="container pending-cancellations-container">
  <div class="grid container-header">
    <div class="col-12 pending-cancellations-header">
      <span class="title">{{ 'TRANSLATE.CONTRACT.CANCELLATION' | translate }}</span>
      <span class="sub-title">{{ 'TRANSLATE.CONTRACT.CANCELLATION.REQUESTS' | translate }}</span>
    </div>
  </div>

  <div class="container-body pending-cancellations-body">
    <div class="pending-cancellations-card">
      <div class="pending-cancellations-card-header">
        <h2>{{ 'TRANSLATE.CONTRACT.PENDING.CANCELLATIONS' | translate }}</h2>
        <p>{{ 'TRANSLATE.CONTRACT.PENDING.CANCELLATIONS.INSTRUCTION' | translate }}</p>
      </div>

      <p-table
        [value]="cancellations"
        styleClass="pending-cancellations-table app-table app-table--condensed"
        responsiveLayout="scroll"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'TRANSLATE.REQUEST.DATE' | translate }}</th>
            <th>{{ 'TRANSLATE.REQUESTED' | translate }}</th>
            <th>{{ 'TRANSLATE.CHASSIS' | translate }}</th>
            <th>{{ 'TRANSLATE.CONTRACT.NUMBER.SINGLE' | translate }}</th>
            <th class="action-header">{{ 'TRANSLATE.ACTION' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item.requestDate | date:'dd/MM/yyyy' }}</td>
            <td>Há {{ item.requestedDays }} dias</td>
            <td class="chassi-cell">{{ item.chassi }}</td>
            <td>{{ item.contractNumber }}</td>
            <td class="action-cell">
              <div class="action-cell-inner">
                <button type="button" class="app-filter-button pending-process-button" (click)="processContract(item)">
                  <i class="pi pi-cog" aria-hidden="true"></i>
                  <span class="action-button-label">{{ 'TRANSLATE.PROCESS' | translate }}</span>
                </button>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="no-request">{{ 'TRANSLATE.NO.PENDING.REQUESTS' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
